"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileOptions = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const Input_1 = require("@jsonjoy.com/ui/lib/2-inline-block/Input");
const context_1 = require("./context");
const use_t_1 = require("use-t");
const blockClass = (0, nano_theme_1.rule)({
    bxz: 'border-box',
    d: 'flex',
    fld: 'column',
    gap: '12px',
    maxW: '500px',
});
const stopInputKeyDown = (event) => {
    event.stopPropagation();
};
const FileOptions = () => {
    const [t] = (0, use_t_1.useT)();
    const state = (0, context_1.useFileOptions)();
    const caption = state.caption.use();
    const displayName = state.displayName.use();
    return (React.createElement("div", { className: blockClass },
        React.createElement(Input_1.Input, { type: "text", value: displayName, label: t('File name'), placeholder: t('Original filename'), onChange: state.setDisplayName, onKeyDown: stopInputKeyDown, onEnter: (event) => {
                event.preventDefault();
                event.stopPropagation();
                state.apply();
            }, onEsc: (event) => {
                event.preventDefault();
                event.stopPropagation();
                state.cancel();
            } }),
        React.createElement(Input_1.Input, { type: "text", value: caption, label: t('Caption (optional)'), placeholder: t('About this file'), onChange: state.setCaption, onKeyDown: stopInputKeyDown, onEnter: (event) => {
                event.preventDefault();
                event.stopPropagation();
                state.apply();
            }, onEsc: (event) => {
                event.preventDefault();
                event.stopPropagation();
                state.cancel();
            } })));
};
exports.FileOptions = FileOptions;
